export { DepositLimits } from './DepositLimits';
export type { DepositLimitsProps, DepositLimitsTranslations, DepositLimitsValue } from './types';
